import { render, staticRenderFns } from "./VProjectDropdown.vue?vue&type=template&id=badee58c&"
import script from "./VProjectDropdown.vue?vue&type=script&lang=ts&"
export * from "./VProjectDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports